var Shopify = Shopify || {};

Shopify.sign = '$';
Shopify.money = function (cents) {
  cents = parseInt(cents, 10) || 0;
  const integer = Math.floor(cents / 100);
  const decimal = cents % 100;
  return `${Shopify.sign}${integer}.${decimal.toString().padStart(2, '0')}`;
};

Shopify.moneyWithoutTrailingZeros = function (cents) {
  cents = parseInt(cents, 10) || 0;
  const integer = Math.floor(cents / 100);
  const decimal = (cents % 100).toString().padStart(2, '0').replace(/0+$/, '');
  return `${Shopify.sign}${integer}${decimal ? `.${decimal}` : ''}`;
};

Shopify.moneyWithoutCurrency = function (cents) {
  const money = Shopify.money(cents);
  return money.replace(Shopify.sign, '');
};

Shopify.remove = function (str1, str2) {
  return str1.split(str2).join('');
};

Shopify.renderPriceTag = function (cents, customClass = '') {
  cents = parseInt(cents, 10) || 0;
  const moneyWithoutTrailingZeros = Shopify.moneyWithoutTrailingZeros(cents);
  const moneyWithoutCurrencyAndTrailingZeros = Shopify.remove(moneyWithoutTrailingZeros, Shopify.sign);
  const integerPart = moneyWithoutCurrencyAndTrailingZeros.split('.')[0];
  const decimalPart = Shopify.remove(moneyWithoutCurrencyAndTrailingZeros, integerPart);
  return `
    <span class="inline-flex items-center leading-none">
      <sup class="text-[12px] -top-[1px]">${Shopify.sign}</sup>
      <span class="text-[18px]${customClass ? ` ${customClass}` : ''}">${integerPart}</span>
      ${decimalPart ? `<sup class="text-[12px] -top-[2px]">${decimalPart}</sup>` : ''}
    </span>
  `;
};
